import dotProp from 'dot-prop-immutable'
import { createStore } from 'effector'
import { fetchConfigFx } from './effects'
import { customizeConfig, setConfig } from './events'
import { WidgetConfig } from '@loctypes/widget-config'

export const $config = createStore<WidgetConfig>(null!)

$config.on([fetchConfigFx.doneData, setConfig], (_, config) => ({ ...config }))

$config.on(customizeConfig, (state, customConfig) => {
  if (customConfig) {
    Object.entries(customConfig).forEach(([dotKey, value]) => {
      state = dotProp.set(state, dotKey, value)
    })
  }

  return { ...state }
})
